export const checkIsRPCParams = queryParams => !!queryParams.objectTypeId;
export const checkIsRPCAssignee = assignee => !!assignee && !!assignee.availabilityStatus;
export const checkIsRPCAssigneeResponse = response => checkIsRPCAssignee(response.assignee);
export const checkIsRPCAssigneesResponse = response => checkIsRPCAssignee(response.results[0]);